// extracted by mini-css-extract-plugin
export default {"modalWrapper":"CreateClassesModal_modalWrapper__O8C5L","selectWithCreateButton":"CreateClassesModal_selectWithCreateButton__48ptL"};